// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1WtP_","resendInfoText":"OnGoingPaymentBox_resendInfoText__2WA4Q"};